import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';

import { Trans } from 'react-i18next'

function DeleteFlexTimeDialog({ open, onClose, onSubmit, userId }) {

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
            >

                <DialogTitle>
                    <Trans i18nKey='wirklichLöschenTitel' ns='employeeBaseDataPage'>
                        Arbeitszeitkonto wirklich löschen?
                    </Trans>
                </DialogTitle>
                <DialogContent>
                    <p>
                        <Trans i18nKey='wirklichLöschenText' ns='employeeBaseDataPage'>
                            Der initiale Kontostand und das hinterlegte Arbeitszeitmodell wird gelöscht. Dadurch geht auch der aktuelle Stand an
                            Mehrarbeits- bzw. Minusstunden verloren.
                        </Trans>

                    </p>
                    <p>
                        <Trans i18nKey='sicher' ns='employeeBaseDataPage'>
                            Willst du das Arbeitszeitkonto trotzdem löschen?
                        </Trans>

                    </p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>
                        <Trans ns='common' i18nKey='abbrechen'>Abbrechen</Trans>
                    </Button>
                    <Button variant='contained' onClick={() => {
                        onSubmit(false, userId);
                        onClose();
                    }}>
                        <Trans i18nKey='trotzdemLöschen' ns='employeeBaseDataPage'>Trotzdem löschen</Trans>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )

}

export default DeleteFlexTimeDialog
